import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getCompanyStatusStatisticsSucceed, requestFailure } from '../actions'

export function* getCompanyStatisticsSaga(companyApi: {
  getCompanyStatistics: (...args: any[]) => any
}) {
  try {
    const { data } = yield call(companyApi.getCompanyStatistics)
    yield put(getCompanyStatusStatisticsSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
